/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { EventToken } from "./EventToken";
export const EventTokenResponse = core.serialization.object({
    data: EventToken,
});
